import { createClient } from '@supabase/supabase-js';

// Credentials lus depuis l'environnement de build Vite (jamais hardcodés) : permet de pointer
// chaque déploiement vers un projet Supabase distinct — Production vs Preview/staging — sans
// toucher au code (séparation des environnements, ISO 27001 A.8.31). Voir CLAUDE.md racine :
// Supabase ne sert QUE l'auth, toutes les données métier passent par apiClient/backend.
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Fail-fast au chargement du module : une env var manquante est une erreur de config de
// déploiement (Vercel scope Production/Preview) ou de dev (.env.local), pas un état runtime
// récupérable. On casse bruyamment au boot plutôt que de laisser un client cassé produire des
// échecs d'auth opaques plus loin. `supabase` est importé par ~18 fichiers comme non-null.
if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error(
    "[supabase/client] Credentials Supabase absents de l'environnement de build. " +
      'VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY sont requis. ' +
      "Vérifier les variables d'env Vercel (scope Production ET Preview) et le .env.local en dev. " +
      `Présence — VITE_SUPABASE_URL: ${Boolean(SUPABASE_URL)}, VITE_SUPABASE_ANON_KEY: ${Boolean(SUPABASE_ANON_KEY)}.`,
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
